import * as React from "react";
import { config } from "../../../config/domain";

interface statusScreenProps {
  headerText?: string;
  desc?: string;
  status: "Pending" | "Rejected" | "Success";
}

export const StatusScreen = (props: statusScreenProps) => {
  function redirect(url: string) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    }
  }
  return (
    <>
      {/* <> */}

      {props.status === "Pending" && (
        <div>
          <div className="inProgress_wrap finalScreen poaDownload iconPopupBg paymentFailed">
            <div className="inProgress">
              <div className="inProgress__dots">
                <div className="dot1 dot-active"></div>
                <div className="dot2"></div>
                <div className="dot3"></div>
              </div>
            </div>
            {props.headerText && (
              <div className="">
                <p className="field-head text-center">{props.headerText}</p>
                <p
                  className={
                    window.location.href.includes("email-mobile-modification")
                      ? "field-subHead desc desc1 text-center grey-text "
                      : "field-subHead desc text-center grey-text"
                  }
                >
                  {props.desc}
                </p>
              </div>
            )}
            {!props.headerText && (
              <div className="iconPopupWrap">
                <h6>Payment Failed</h6>
                <p>
                  Please <a href="">Contact your RM</a> or write to us at
                </p>
                <a className="mail" href="mailto:helpdesk@nuvama.com">
                  helpdesk@nuvama.com
                </a>
                <div>
                  <button
                    className="ed_button"
                    onClick={(e) => {
                      e.preventDefault();
                      localStorage.removeItem("paymentReponse");
                      redirect(
                        config.root +
                          "/clientarea/service-request/account-reactivation"
                      );
                    }}
                  >
                    Try Again
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* </div> */}

      {props.status === "Rejected" && (
        <div className="finalScreen poaDownload iconPopupBg paymentFailed">
          <div>
            <div className="failed-validate">
              <div className="icon">
                <div className="validate__dots">
                  <div className="failed-icon">
                    <i className="edel-icon-exclamation"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="iconPopupWrap">
              <h6>Payment Failed</h6>
              <p>
                Please <a href="">Contact your RM</a> or write to us at
              </p>
              <a className="mail" href="mailto:helpdesk@nuvama.com">
                helpdesk@nuvama.com
              </a>
              <div>
                <button
                  className="ed_button"
                  onClick={(e) => {
                    e.preventDefault();
                    localStorage.removeItem("paymentReponse");
                    redirect(
                      config.root +
                        "/clientarea/service-request/account-reactivation"
                    );
                  }}
                >
                  Try Again
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <hr /> */}
      {/* requestSent html */}
      {props.status === "Success" && (
        <div className="finalScreen poaDownload iconPopupBg requestSent">
          <div>
            <div className="failed-validate">
              <div className="icon">
                <div className="validate__dots">
                  <div className="failed-icon">
                    <i className="edel-icon-request-send"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="iconPopupWrap">
              <h6>Request sent</h6>
              <p>
                Please <a href="">Contact your RM</a> or write to us at
              </p>
              <a href="mailto:helpdesk@nuvama.com">helpdesk@nuvama.com</a>
              <div>
                <button
                  className="ed_button"
                  onClick={(e) => {
                    e.preventDefault();
                    localStorage.removeItem("paymentReponse");
                    redirect(
                      config.root +
                        "/clientarea/service-request/account-reactivation"
                    );
                  }}
                >
                  Try Again
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
